import { Page } from '../../types'

type DockerStartApplicationProps = { 
    hasLicenseFile: boolean
}

const render = ({ hasLicenseFile }: DockerStartApplicationProps) => {
    return <>
        <p>
            You now have a Docker file and your application code. {hasLicenseFile && 
            <>You also have a license file; we will assume it is called <code>gurobi.lic</code>. </>}
            All these files should be stored in a single folder.
        </p>
        {hasLicenseFile && <p>
            We encourage you not to store your license file inside the container image for two reasons. First of all,
            changing your license file would require rebuilding your image. Second, there is a risk that your license
            key is reverse engineered from the container image. Instead, you should mount your license file.
        </p>}
        <p>
            First make sure to build your container using <code>docker build -t &lt;appname&gt; .</code> Note that
            the use of the dot <code>.</code> assumes you execute this command from the same folder where the files
            mentioned above are stored and the docker file is called <code>Dockerfile</code>
        </p>
        {hasLicenseFile ? <p>To start your container, use the following command:<br/><code>docker run --volume=$PWD/gurobi.lic:/opt/gurobi/gurobi.lic:ro &lt;appname&gt;</code></p> :
        <p>To start your container, use <code>docker run &lt;appname&gt;</code></p>}
    </>
}

const DockerStartApplication : Page<DockerStartApplicationProps> = { key: 'docker-start-app', title: 'Start application container', render }

export default DockerStartApplication